/* eslint-disable import/order */
import esUI from './es/es.ui.json'
import frUI from './fr/fr.ui.json'
import itUI from './it/it.ui.json'

import esBreeds from './es/es.breeds.json'
import frBreeds from './fr/fr.breeds.json'
import itBreeds from './it/it.breeds.json'

const messages = {
  es: { ...esUI, ...esBreeds },
  fr: { ...frUI, ...frBreeds },
  it: { ...itUI, ...itBreeds },
}

const commonNumberFormats = {
  decimals: {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  },
  currency: {
    style: 'currency',
    currency: 'EUR',
  },
  percent: {
    style: 'percent',
  },
}

const numberFormats = {
  es: commonNumberFormats,
  fr: commonNumberFormats,
  it: commonNumberFormats,
}

const commonDatetimeFormats = {
  time: {
    hour: 'numeric', minute: 'numeric',
  },
  compact: {
    weekday: 'long', day: 'numeric',
  },
  compactMonth: {
    month: 'short', weekday: 'short', day: 'numeric',
  },
  longWeek: {
    month: 'short', weekday: 'long', day: 'numeric',
  },
  short: {
    year: 'numeric', month: 'short', day: 'numeric',
  },
  long: {
    year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric', hour12: false,
  },
  longDayMonthHour: {
    month: 'long', weekday: 'long', day: 'numeric', hour: 'numeric', minute: 'numeric', hour12: false,
  },
  dayMonth: {
    month: 'long', day: 'numeric',
  },
  shortDayMonth: {
    month: 'short', day: 'numeric',
  },
  weekday: {
    year: 'numeric', month: 'long', day: 'numeric', weekday: 'long',
  },
  shortMonthOnly: {
    month: 'short',
  },
  longMonthOnly: {
    month: 'long',
  },
  weekdayOnly: {
    weekday: 'long',
  },
  numeric: {
    day: 'numeric', month: 'numeric', year: 'numeric',
  },
}

const datetimeFormats = {
  es: commonDatetimeFormats,
  fr: commonDatetimeFormats,
  it: commonDatetimeFormats,
}

export default {
  legacy: false, // set 'false' to use Composition API
  globalInjection: true,
  useScope: 'global',
  locale: 'es',
  availableLocales: ['es', 'fr', 'it'],
  messages,
  fallbackLocale: 'es',
  numberFormats,
  datetimeFormats,
  silentTranslationWarn: true,
  warnHtmlMessage: false,
}
